import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { fetchGeoFilters } from '../../../../store/slice/filter-slice';
import Button from '../../Common/Button';
import FiltersSetup from './FiltersSetup';
import filters from '../../../../assets/img/svg/buttons/filter.svg';
import UpArrow from '../../../../assets/img/svg/buttons/up-arrow.svg';
import { useCloseOnScrollAndClickOutside } from '../../../../hook/useCloseOnScrollAndClickOutside';
import { useLocation } from 'react-router-dom';
import { CASH_REGISTER_URL } from '../../../../util/url';

const payload = {
  CompanyID: null,
  RegionID: null,
  GroupID: null,
  LocationID: null,
  DeviceID: null,
  GetAllAbove: false,
  GetAllBelow: false,
  GetUserLevel: true,
};

const CustomFilter = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [openFilterDropDown, setOpenFilterDropDown] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === CASH_REGISTER_URL) {
      setOpenFilterDropDown(true);
    }
  }, [location.pathname]);

  const openFilters = () => {
    setOpenFilterDropDown((prevState) => !prevState);
  };

  useEffect(() => {
    dispatch(fetchGeoFilters(payload));
  }, [dispatch]);

  useCloseOnScrollAndClickOutside(setOpenFilterDropDown, menuRef);

  return (
    <div className="filter_button_wrapper">
      <div ref={menuRef}>
        <Button
          icon={filters}
          onClick={openFilters}
          variant={`${openFilterDropDown ? 'filled' : ''}`}
          className="filter_button"
        >
          {openFilterDropDown && (
            <>
              <span className="button_name">{t('statisticPage.header.buttons.filters')}</span>
              <img src={UpArrow} alt="UpArrow" />
            </>
          )}
        </Button>
        <FiltersSetup showDropdown={openFilterDropDown} setOpenFilterDropDown={setOpenFilterDropDown} />
      </div>
    </div>
  );
};
export default CustomFilter;
